import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useFormContext } from 'react-hook-form';
import IconButton from '@mui/material/IconButton';
import { MouseEvent, useEffect, useState } from 'react';
import infoIconUrl from '@repo/assets/icons/info.svg?url';
import { useIsMounted } from '@repo/hooks';
import { useLiberisContext } from '@repo/app-contexts/liberis';

import { RequestedLoanValuesWithP24Agreements } from '@/components/loan-offer-data-process/form/form.schema';

import { titleProps } from '../common/helpers/title-props';
import { ContactDataDisclaimer } from '../common/components/contact-data-disclaimer';

export function LiberisBeneficientDataTitle() {
  const { t } = useTranslation();
  const { activeBeneficientIndex } = useLiberisContext();
  const { getValues } = useFormContext<RequestedLoanValuesWithP24Agreements>();
  const [isHintVisible, setIsHintVisible] = useState<boolean>(false);
  const isMounted = useIsMounted();
  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation(); // Zatrzymuje propagację zdarzenia, aby uniknąć natychmiastowego wyzwalania click na dokumencie
    setIsHintVisible((value) => !value);
  };

  useEffect(() => {
    const handleHideHint = () => {
      if (isMounted()) {
        setIsHintVisible(false);
      }
    };
    if (isHintVisible) {
      document.addEventListener('click', handleHideHint);
    }

    return () => {
      if (isHintVisible) {
        document.removeEventListener('click', handleHideHint);
      }
    };
  }, [isHintVisible, isMounted]);
  const person = getValues().person;

  return (
    <Box width="100%">
      <Typography {...titleProps} sx={{ marginBottom: '8px' }}>
        {person[activeBeneficientIndex].name}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography fontSize={20} lineHeight={'24px'}>
          {t('welcomePage.loanApplicationPossible.liberis.beneficientData.subtitle')}
        </Typography>
        <IconButton
          sx={{
            '&:hover': { backgroundColor: 'transparent' },
          }}
          onClick={handleButtonClick}
        >
          <Box component="img" src={infoIconUrl} alt="info" />
        </IconButton>
      </Box>

      <Box position="relative" width="100%">
        {isHintVisible ? (
          <Box
            sx={{
              position: 'absolute',
              top: '-14px',
              left: 0,
              width: '100%',
              zIndex: 1,
            }}
          >
            <ContactDataDisclaimer />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
